import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  withStyles,
  Tooltip,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";
import { ReactComponent as RemoveRecoIcon } from "../../../assets/FollowUpDeleteIcon.svg";
import { ReactComponent as InfoTooltipIcon } from "../../../assets/info-tooltip-icon.svg";
import { ReactComponent as RemoveRecoIconHover } from "../../../assets/delete-hover.svg";
import { useDispatch } from "react-redux";
import {
  deleteSftpConnection,
  getSftpConnection,
  showAlert,
  updateDataTypeStatus,
  updateSftpConnection,
} from "../../../actions/radminUploads";
import RemoveConfirmation from "../ReportCohort/RemoveConfirmation";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import { extractLocalTimeParts, hasUnderscore } from "../../../utils/utils";

const SFTPConnection = () => {
  const styles = {
    root: {
      padding: "32px",
      backgroundColor: "#f5f5f5",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      fontFamily: '"Roboto Condensed", sans-serif',
    },
    heading: {
      fontWeight: 700,
      fontSize: "24px",
      lineHeight: "28.8px",
      color: "#0c2945",
      marginBottom: "62px",
      fontFamily: '"Roboto Condensed", sans-serif',
    },
    bodyText: {
      fontSize: "16px",
      lineHeight: "24px",
      color: "#34495E",
      marginBottom: "30px",
    },
    containerGrid: {
      display: "flex",
      flexDirection: "row",
      gap: "136px",
      marginBottom: "32px",
      "@media (min-width: 960px)": {
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "77px",
      },
    },
    leftCol: {
      flex: "2",
    },
    rightCol: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      flex: "12",
    },
    sectionRowContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      marginBottom: "20px",
      "@media (min-width: 960px)": {
        gap: "30px",
      },
    },
    checkboxLabel: {
      display: "flex",
      alignItems: "center",
      marginBottom: "28px",
    },
    checkboxTitle: {
      fontWeight: "700",
      fontSize: "14px",
      color: "#6d6e6e",
      marginLeft: "5px",
      textAlign: "left",
      lineHeight: "17px",
      fontStyle: "normal",
    },
    inputFieldContainer: {
      display: "flex",
      flexDirection: "column",
      width: "calc(25% - 15px)",
      minWidth: "180px",
      marginBottom: "15px",
      "@media (max-width: 1200px)": {
        width: "calc(33.33% - 15px)",
      },
      "@media (max-width: 960px)": {
        width: "calc(50% - 10px)",
      },
      "@media (max-width: 600px)": {
        width: "100%",
      },
    },
    inputFieldTitle: {
      fontSize: "14px",
      fontWeight: "bold",
      color: "#6d6e6e",
      marginBottom: "4px",
    },
    textField: {
      border: "1px solid #e0e0e0",
      borderRadius: "5px",
      padding: "10px 12px",
      fontSize: "0.875rem",
      backgroundColor: "#fff",
      height: "38px",
      boxSizing: "border-box",
      width: "100%",
    },
    textFieldInvalid: {
      borderColor: "red",
    },
    errorMessage: {
      color: "red",
      fontSize: "0.75rem",
      marginTop: "4px",
    },
    timeInput: {
      width: "45px",
      textAlign: "center",
      padding: "10px 0",
    },
    amPmContainer: {
      marginLeft: "8px",
      borderRadius: "4px",
      width: "60px",
      height: "38px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      cursor: "pointer",
    },
    amPmText: {
      fontSize: "14px",
      fontWeight: "bold",
      padding: "5px 3px",
      lineHeight: "18px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "78%",
      height: "100%",
    },
    amPmTextActive: {
      color: "#2196F3",
      border: "3px solid #00AEEF",
      borderRadius: "5px",
    },
    amPmTextInactive: {
      backgroundColor: "transparent",
      color: "#B5B5B5",
    },
    delimiterButton: {
      borderRadius: "8px",
      textTransform: "none",
      minWidth: "153px",
      fontSize: "14px",
      height: "26px",
      transition: "all 0.3s ease",
      padding: "6px 12px",
      cursor: "pointer",
      boxSizing: "border-box",
      border: "2px solid",
    },
    delimiterButtonActive: {
      color: "#00AEEF",
      backgroundColor: "#EFFBFF",
      borderColor: "#00AEEF",
      fontWeight: 700,
    },
    delimiterButtonInactive: {
      color: "#B5B5B5",
      backgroundColor: "#FFFFFF",
      borderColor: "#B5B5B5",
      fontWeight: 400,
    },
    passwordToggle: {
      backgroundColor: "transparent",
      border: "none",
      color: "#555",
      cursor: "pointer",
      fontSize: "0.8rem",
      marginLeft: "5px",
    },
    rowActionButton: {
      padding: "10px 10px",
      borderRadius: "5px",
      cursor: "pointer",
      marginLeft: "10px",
      fontSize: "12px",
      textTransform: "none",
      border: "1px solid",
    },
    saveButton: {
      padding: "12px 24px",
      borderRadius: "8px",
      textTransform: "none",
      fontWeight: "bold",
      boxShadow: "0px 4px 10px rgba(0, 123, 255, 0.2)",
      border: "none",
      cursor: "pointer",
      marginTop: "40px",
      "&:hover": {
        backgroundColor: "#0056b3",
        boxShadow: "0px 6px 12px rgba(0, 123, 255, 0.3)",
      },
    },
    addMoreButton: {
      backgroundColor: "#2196f3",
      color: "#fff",
      padding: "8px 15px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      marginTop: "20px",
      fontSize: "14px",
      marginBottom: "15px",
      fontWeight: "bold",
    },
    horizontalRowContent: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "20px",
      alignItems: "flex-start",
      marginBottom: "15px",
      paddingBottom: "10px",
      borderBottom: "1px solid #eee",
    },
    rowActions: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "15px",
      gap: "10px",
      width: "100%",
    },
  };

  const StyledTooltip = (props) => {
    const { className, ...other } = props;

    return (
      <Tooltip
        {...other}
        PopperProps={{
          className: className,
          style: {
            backgroundColor: "#AEE3F8",
            marginBottom: "20px",
            borderRadius: "4px",
            zIndex: 3,
          },
        }}
      />
    );
  };

  const StyledTooltipWrapper = withStyles(() => ({
    tooltip: {
      backgroundColor: "transparent",
      color: "black!important",
      fontSize: "14px!important",
      fontWeight: 400 + "!important",
      width: "220px",
      padding: "10px",
      textAlign: "center",
      margin: "0px",
      position: "relative",
    },
  }))(StyledTooltip);

  const IconContainer = styled.span`
    position: relative;
    cursor: pointer;
    display: inline-block;
    width: 30px;
    height: 20px;

    &:hover svg:not(.light) {
      display: none;
    }

    &:hover svg.light {
      display: block;
    }

    svg {
      position: absolute;
      top: 0;
      left: 0;
    }

    svg.light {
      display: none;
    }
  `;

  const StyledButton = styled.button`
    border: 2px solid ${({ active }) => (active ? "#00AEEF" : "#B5B5B5")};
    color: ${({ active }) => (active ? "#00AEEF" : "#B5B5B5")};
    background: ${({ active }) => (active ? "#EFFBFF" : "#FFFFFF")};
    min-width: 153px;
    font-size: 14px;
    font-weight: ${({ active }) => (active ? 700 : 400)};
    height: 26px;
    cursor: pointer;
    position: relative;

    &:first-child {
      border-radius: 4px 0 0 4px;
      border-right: 1px solid #00aeef;
    }

    &:last-child {
      border-radius: 0 4px 4px 0;
      border-left: 1px solid #00aeef;
    }
  `;

  const dispatch = useDispatch();
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedModuleType, setSelectedModuleType] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState("");
  const [loadingRowId, setLoadingRowId] = useState(null);
  const [availableDataTypes, setAvailableDataTypes] = useState([]);
  const [sftpData, setSftpData] = useState({
    reports: {
      isChecked: false,
      rows: [
        {
          domainName: "",
          port: 22,
          username: "",
          password: "",
          showPassword: false,
          runHour: "06",
          runMinute: "30",
          amPm: "AM",
          delimiterIsPipe: true,
          errors: {},
        },
      ],
    },
    appointments: {
      isChecked: false,
      rows: [
        {
          domainName: "",
          port: 22,
          username: "",
          password: "",
          showPassword: false,
          runHour: "06",
          runMinute: "30",
          amPm: "AM",
          delimiterIsPipe: true,
          errors: {},
        },
      ],
    },
    prescriptions: {
      isChecked: false,
      rows: [
        {
          domainName: "",
          port: 22,
          username: "",
          password: "",
          showPassword: false,
          runHour: "06",
          runMinute: "30",
          amPm: "AM",
          delimiterIsPipe: true,
          errors: {},
        },
      ],
    },
  });

  function transformData(results) {
    const grouped = {};
    const expectedTypes = ["reports", "appointments", "prescriptions"];

    expectedTypes.forEach((type, index) => {
      grouped[type] = {
        isChecked: false,
        rows: [],
      };
    });

    results.forEach((item) => {
      const key = item.data_type.toLowerCase();
      if (!expectedTypes.includes(key)) return;

      if (!grouped[key]) {
        grouped[key] = { isChecked: false, rows: [] };
      }

      const [hourStr, minuteStr] = item.run_at.split(":");
      let hour = parseInt(hourStr, 10);
      hour = hour % 12 || 12;

      grouped[key].rows.push({
        id: item.id ?? null,
        domainName: item.host,
        port: item.port,
        username: item.site_username,
        password: item.password,
        showPassword: false,
        runHour: extractLocalTimeParts(item.run_at)?.hour,
        runMinute: extractLocalTimeParts(item.run_at)?.minute,
        amPm: extractLocalTimeParts(item.run_at)?.period,
        delimiterIsPipe: item.delimiter === "Pipe",
        errors: {},
      });

      if (item.is_active) {
        grouped[key].isChecked = true;
      }
    });

    expectedTypes.forEach((type, index) => {
      if (grouped[type].rows.length === 0) {
        grouped[type].rows.push({
          id: `_${index + 1}`,
          domainName: "",
          port: 22,
          username: "",
          password: "",
          showPassword: false,
          runHour: "06",
          runMinute: "30",
          amPm: "AM",
          delimiterIsPipe: true,
          errors: {},
        });
      }
    });

    return grouped;
  }

  useEffect(() => {
    setIsLoading(true);
    dispatch(getSftpConnection())
      .then((data) => {
        if (data) {
          const types = [
            ...new Set(data?.map((item) => item?.data_type.toLowerCase())),
          ];
          setAvailableDataTypes(types);
          const structuredData = transformData(data);
          setSftpData(structuredData);
        }
      })
      .catch((error) => console.log("error", error))
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const deleteSftpHandler = async () => {
    setIsLoadingDelete(true);
    if (!hasUnderscore(selectedRowId)) {
      try {
        await dispatch(deleteSftpConnection(selectedRowId));
      } catch (error) {
        console.error("Error deleting SFTP connection:", error);
      }
    }

    setSftpData((prevData) => {
      const currentModule = prevData[selectedModuleType];
      const updatedRows =
        currentModule?.rows?.filter((item) => item.id !== selectedRowId) || [];

      return {
        ...prevData,
        [selectedModuleType]: {
          ...currentModule,
          rows: updatedRows,
          isChecked: updatedRows.length > 0 ? currentModule.isChecked : false,
        },
      };
    });

    if (hasUnderscore(selectedRowId)) {
      dispatch(showAlert("success", "Success", "deleted successfully!"));
    }

    setSelectedModuleType(selectedModuleType);
    setSelectedRowId(selectedRowId);
    setIsLoadingDelete(false);
    setRemoveDialogOpen(false);
  };

  const dialogHandler = (moduleType, rowId) => {
    setRemoveDialogOpen(!removeDialogOpen);
    setSelectedModuleType(moduleType);
    setSelectedRowId(rowId);
    window.analytics.track("SFTP-Report-Delete-Button-Click");
  };

  const updateSftpField = (moduleType, rowId, field, value) => {
    setSftpData((prevData) => {
      const updatedModuleItems = prevData[moduleType]?.rows?.map((item) =>
        item.id === rowId ? { ...item, [field]: value } : item
      );
      return {
        ...prevData,
        [moduleType]: { ...prevData[moduleType], rows: updatedModuleItems },
      };
    });
  };

  const isValidTime = (hour, minute) => {
    const h = parseInt(hour, 10);
    const m = parseInt(minute, 10);
    return h >= 1 && h <= 12 && m >= 0 && m <= 59;
  };

  const validateRow = (row) => {
    const errors = {};
    if (!row.domainName) {
      errors.domainName = "Domain name is required.";
    }
    if (row.port < 1 || row.port > 65535) {
      errors.port = "Port must be between 1 and 65535.";
    }
    if (!row.username) {
      errors.username = "Username is required.";
    }
    if (!row.password) {
      errors.password = "Password is required.";
    }
    if (row.runHour !== undefined && !isValidTime(row.runHour, row.runMinute)) {
      errors.runTime = "Invalid time.";
    }

    return errors;
  };

  const handleRowSave = (moduleType, rowId, data) => {
    setLoadingRowId(rowId);
    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    const utcTime = moment(
      `${data?.runHour}:${data?.runMinute} ${data?.amPm}`,
      "hh:mm A"
    )
      .utc()
      .format();
    const dateObj = new Date(utcTime);

    const hours = String(dateObj.getUTCHours()).padStart(2, "0");
    const minutes = String(dateObj.getUTCMinutes()).padStart(2, "0");
    const seconds = String(dateObj.getUTCSeconds()).padStart(2, "0");

    const timeOnlyUTC = `${hours}:${minutes}:${seconds}`;

    setSftpData((prevData) => {
      const updatedModuleItems = prevData[moduleType]?.rows?.map((item) => {
        if (item.id === rowId) {
          const errors = validateRow(item);
          if (Object.keys(errors).length === 0) {
            const payloadData = {
              data_type: capitalizeFirstLetter(moduleType),
              host: data?.domainName,
              port: data?.port,
              site_username: data?.username,
              password: data?.password,
              is_active: true,
              delimiter: data?.delimiterIsPipe
                ? "Pipe"
                : "Comma",
              run_at: timeOnlyUTC,
            };

            dispatch(updateSftpConnection(rowId, payloadData))
              .then((response) => {
                if (rowId !== response?.data?.id) {
                  const newRow = {
                    id: response?.data?.id,
                    domainName: response?.data?.host,
                    port: response?.data?.port,
                    username: response?.data?.site_username,
                    password: response?.data?.password,
                    showPassword: false,
                    runHour: extractLocalTimeParts(response?.data?.run_at)
                      ?.hour,
                    runMinute: extractLocalTimeParts(response?.data?.run_at)
                      ?.minute,
                    amPm: extractLocalTimeParts(response?.data?.run_at)?.period,
                    delimiterIsPipe:
                      response?.data?.delimiter === "Pipe",
                    errors: {},
                  };

                  setSftpData((prev) => {
                    const filteredRows = prev[moduleType]?.rows?.filter(
                      (r) => r.id !== rowId
                    );

                    return {
                      ...prev,
                      [moduleType]: {
                        ...prev[moduleType],
                        rows: [...filteredRows, newRow],
                      },
                    };
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
              })
              .finally(() => {
                setLoadingRowId(null);
              });
          } else if(Object.keys(errors).length > 0) {
             setLoadingRowId();
          } else {
             setLoadingRowId();
            console.log(
              `Validation errors in row for ${moduleType} (ID: ${rowId}).`
            );
          }

          return { ...item, errors: errors };
        }
        return item;
      });
      return {
        ...prevData,
        [moduleType]: { ...prevData[moduleType], rows: updatedModuleItems },
      };
    });
  };

  const addSftpRow = (moduleType) => {
    const newId =
      (sftpData[moduleType]?.rows.length > 0
        ? Math.max(...sftpData[moduleType]?.rows?.map((item) => item.id))
        : 0) + 1;

    const newRow = {
      id: `_${newId}`,
      domainName: "",
      port: 22,
      username: "",
      password: "",
      showPassword: false,
      errors: {},
    };

    newRow.runHour = "01";
    newRow.runMinute = "00";
    newRow.amPm = "AM";
    newRow.delimiterIsPipe = true;

    setSftpData((prevData) => ({
      ...prevData,
      [moduleType]: {
        ...prevData[moduleType],
        rows: [...prevData[moduleType]?.rows, newRow],
      },
    }));
  };

  const renderModuleSection = (moduleType, moduleConfig) => {
    const showRunAtAndDelimiter = [
      "reports",
      "appointments",
      "prescriptions",
    ].includes(moduleType);
    const items = moduleConfig?.rows || [];

    return (
      <div key={moduleType}>
        <label style={styles.checkboxLabel}>
          <input
            type="checkbox"
            checked={moduleConfig?.isChecked}
            onChange={() => {
              const capitalizedType =
                moduleType.charAt(0).toUpperCase() + moduleType.slice(1);
              const payload = {
                is_active: !moduleConfig?.isChecked,
                data_type: capitalizedType,
              };
              if (moduleConfig?.rows?.length !== 0 && availableDataTypes.includes(moduleType)) {
                dispatch(updateDataTypeStatus(payload)).then((response) => {
                  if (response) {
                    setSftpData((prevData) => ({
                      ...prevData,
                      [moduleType]: {
                        ...prevData[moduleType],
                        isChecked: !prevData[moduleType]?.isChecked,
                      },
                    }));
                  }
                });
              } else {
                setSftpData((prevData) => ({
                  ...prevData,
                  [moduleType]: {
                    ...prevData[moduleType],
                    isChecked: !prevData[moduleType]?.isChecked,
                  },
                }));
              }
            }}
          />
          <span style={styles.checkboxTitle}>
            {` ${moduleType.charAt(0).toUpperCase() + moduleType.slice(1)}`}
          </span>
          <StyledTooltipWrapper
            placement="right"
            title={
              "Checking/Unchecking a model would archive/unarchive all the records for that model"
            }
          >
            <InfoTooltipIcon
              style={{
                cursor: "pointer",
                alignSelf: "center",
                marginLeft: "9px",
              }}
            />
          </StyledTooltipWrapper>
        </label>

        {moduleConfig?.isChecked && (
          <div>
            {items.map((row, index) => (
              <div
                key={row.id}
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  padding: "15px",
                  marginBottom: "15px",
                  backgroundColor: "#fff",
                }}
              >
                <div style={styles.horizontalRowContent}>
                  <div style={styles.inputFieldContainer}>
                    <span style={styles.inputFieldTitle}>
                      SITE DOMAIN NAME/IP ADDRESS*
                    </span>
                    <input
                      type="text"
                      value={row.domainName}
                      onChange={(e) =>
                        updateSftpField(
                          moduleType,
                          row.id,
                          "domainName",
                          e.target.value
                        )
                      }
                      style={{
                        ...styles.textField,
                        ...(row.errors.domainName && styles.textFieldInvalid),
                      }}
                      placeholder="Enter domain name"
                    />
                    {row.errors.domainName && (
                      <span style={styles.errorMessage}>
                        {row.errors.domainName}
                      </span>
                    )}
                  </div>
                  <div style={styles.inputFieldContainer}>
                    <span style={styles.inputFieldTitle}>
                      PORT
                    </span>
                    <input
                      type="number"
                      value={row.port ?? ""}
                      min={1}
                      max={65535}
                      onChange={(e) => {
                        const value = e.target.value;
                      
                        updateSftpField(
                          moduleType,
                          row.id,
                          "port",
                          value === "" ? "" : Number(value)
                        );
                      }}
                      style={{
                        ...styles.textField,
                        ...(row.errors.port && styles.textFieldInvalid),
                      }}
                      placeholder="Enter port"
                    />
                    {row.errors.port && (
                      <span style={styles.errorMessage}>
                        {row.errors.port}
                      </span>
                    )}
                  </div>
            
                  <div style={styles.inputFieldContainer}>
                    <span style={styles.inputFieldTitle}>SITE USERNAME*</span>
                    <input
                      type="text"
                      value={row.username}
                      onChange={(e) =>
                        updateSftpField(
                          moduleType,
                          row.id,
                          "username",
                          e.target.value
                        )
                      }
                      style={{
                        ...styles.textField,
                        ...(row.errors.username && styles.textFieldInvalid),
                      }}
                      placeholder="Enter username"
                    />
                    {row.errors.username && (
                      <span style={styles.errorMessage}>
                        {row.errors.username}
                      </span>
                    )}
                  </div>
                  <div style={styles.inputFieldContainer}>
                    <span style={styles.inputFieldTitle}>SITE PASSWORD*</span>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #e0e0e0",
                        borderRadius: "5px",
                        backgroundColor: "#fff",
                        height: "38px",
                        boxSizing: "border-box",
                        fontSize: "0.875rem",
                        ...(row.errors.password && styles.textFieldInvalid),
                        color: "rgb(255, 255, 255)",
                      }}
                    >
                      <TextField
                        type={row.showPassword ? "text" : "password"}
                        value={row.password}
                        autoComplete="new-password"
                        onChange={(e) =>
                          updateSftpField(
                            moduleType,
                            row.id,
                            "password",
                            e.target.value
                          )
                        }
                        sx={{
                          color: "rgb(255, 255, 255)",
                          fontSize: "0.875rem",
                        }}
                        style={{
                          border: "none",
                          color: "rgb(255, 255, 255)",
                          fontSize: "0.875rem",
                          borderBottom: "none",
                          height: "auto",
                          paddingLeft: "9px",
                        }}
                        placeholder="Enter password"
                        InputProps={{
                          style: { height: "38px" },
                          disableUnderline: true,
                          color: "rgb(255, 255, 255)",
                          fontSize: "0.875rem",
                          autoComplete: "new-password",
                          form: {
                            autoComplete: "off",
                          },
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                size="sm"
                                aria-label="toggle password visibility"
                                onClick={() =>
                                  updateSftpField(
                                    moduleType,
                                    row.id,
                                    "showPassword",
                                    !row.showPassword
                                  )
                                }
                                edge="end"
                              >
                                {row.showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                    {row.errors.password && (
                      <span style={styles.errorMessage}>
                        {row?.errors.password}
                      </span>
                    )}
                  </div>

                  {showRunAtAndDelimiter && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          flexWrap: "wrap",
                          minWidth: "200px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          style={{ color: "#555", marginRight: "8px" }}
                        >
                          Run at
                        </Typography>
                        <input
                          type="number"
                          value={row.runHour}
                          onChange={(e) =>
                            updateSftpField(
                              moduleType,
                              row.id,
                              "runHour",
                              e.target.value
                            )
                          }
                          maxLength="2"
                          style={{
                            ...styles.textField,
                            ...styles.timeInput,
                            ...(row.errors.runTime && styles.textFieldInvalid),
                          }}
                        />
                        <span style={{ fontSize: "1rem" }}>:</span>
                        <input
                          type="number"
                          value={row.runMinute}
                          onChange={(e) =>
                            updateSftpField(
                              moduleType,
                              row.id,
                              "runMinute",
                              e.target.value
                            )
                          }
                          maxLength="2"
                          style={{
                            ...styles.textField,
                            ...styles.timeInput,
                            ...(row.errors.runMinute &&
                              styles.textFieldInvalid),
                          }}
                        />
                        {row?.errors.runTime && (
                          <span style={styles.errorMessage}>
                            {row.errors.runTime}
                          </span>
                        )}
                        <div
                          style={styles.amPmContainer}
                          onClick={() =>
                            updateSftpField(
                              moduleType,
                              row.id,
                              "amPm",
                              row.amPm === "AM" ? "PM" : "AM"
                            )
                          }
                        >
                          <span
                            style={{
                              ...styles.amPmText,
                              ...(row.amPm === "AM"
                                ? styles.amPmTextActive
                                : styles.amPmTextInactive),
                              height: "50%",
                            }}
                          >
                            AM
                          </span>
                          <span
                            style={{
                              ...styles.amPmText,
                              ...(row.amPm === "PM"
                                ? styles.amPmTextActive
                                : styles.amPmTextInactive),
                              height: "50%",
                            }}
                          >
                            PM
                          </span>
                        </div>
                      </div>
                      <Box
                        display="flex"
                        gap="8px"
                        style={{ marginLeft: "20px" }}
                      >
                        <StyledButton
                          active={row?.delimiterIsPipe}
                          onClick={() =>
                            updateSftpField(
                              moduleType,
                              row.id,
                              "delimiterIsPipe",
                              true
                            )
                          }
                        >
                          Pipe delimiter
                        </StyledButton>
                        <StyledButton
                          active={!row?.delimiterIsPipe}
                          onClick={() =>
                            updateSftpField(
                              moduleType,
                              row.id,
                              "delimiterIsPipe",
                              false
                            )
                          }
                        >
                          Comma delimiter
                        </StyledButton>
                      </Box>
                    </>
                  )}
                </div>{" "}
                <div style={styles.rowActions}>
                  <button
                    style={{
                      ...styles.rowActionButton,
                      backgroundColor: "#2196f3",
                      color: "#fff",
                      borderColor: "#2196f3",
                    }}
                    onClick={() => handleRowSave(moduleType, row?.id, row)}
                  >
                    {loadingRowId === row?.id ? (
                      <Spinner animation="border" role="status" size="sm" />
                    ) : (
                      <span>Save</span>
                    )}
                  </button>
                  <div
                    style={{
                      marginBottom: "6px",
                    }}
                    onClick={() => {
                      dialogHandler(moduleType, row.id);
                    }}
                  >
                    <IconContainer>
                      <RemoveRecoIcon />
                      <RemoveRecoIconHover className="light" />
                    </IconContainer>
                  </div>
                </div>
              </div>
            ))}
            {moduleConfig?.rows?.length == 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "10px",
                }}
              >
                No data added
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              {moduleConfig?.isChecked && (
                <button
                  style={styles.addMoreButton}
                  onClick={() => addSftpRow(moduleType)}
                >
                  Add More
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={styles.root}>
      <RemoveConfirmation
        content="Are you sure you want to remove?"
        openDialog={removeDialogOpen}
        dialogHandler={dialogHandler}
        isLoading={isLoadingDelete}
        deleteHandler={deleteSftpHandler}
        heading={"Remove SFTP"}
        removeHeader={"Yes, Remove"}
      />

      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Spinner
            animation="border"
            role="status"
            style={{ margin: "0 10px" }}
          />
        </div>
      ) : (
        <div style={styles.containerGrid}>
          <div style={styles.leftCol}>
            <h4 style={styles.heading}>SFTP Connection</h4>
            <p style={styles.bodyText}>
              Set up a connection for each of the data points via SFTP on a
              regular automated basis. Note that this runs on a daily basis and
              only looks in the home directory. If there is another path, please
              reach out.
            </p>
          </div>
          <div style={styles.rightCol}>
            <div style={styles.sectionRowContainer}>
              {renderModuleSection("reports", sftpData.reports)}

              {renderModuleSection("appointments", sftpData.appointments)}

              {renderModuleSection("prescriptions", sftpData.prescriptions)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SFTPConnection;
